module.exports = __webpack_public_path__ + "img/24.6df1af12.png";